import React from 'react';

const FacultyPage = () => {
  return (
    <div className="min-h-screen bg-bg-default">
      <div className="hero-gradient py-16">
        <div className="page-container text-center text-white">
          <span className="badge-accent mb-4 inline-flex justify-center">Mentors from IITs &amp; AIIMS</span>
          <h1 className="text-4xl font-bold drop-shadow">Our Faculty</h1>
          <p className="mt-2 text-white/80">Experienced educators across Physics, Chemistry, Biology &amp; Maths</p>
        </div>
      </div>

      <div className="page-container py-12">
        {subjects.map((subject) => (
          <div key={subject.name} className="mb-12">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-semibold text-primary">{subject.name}</h2>
              <span className="badge-accent">Average 12+ yrs experience</span>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              {subject.faculty.map((t) => (
                <div key={t.name} className="card p-6 text-center border-t-4 border-primary/40">
                  <img src={t.image} alt={t.name} className="w-32 h-32 rounded-full mx-auto mb-4 object-cover shadow-soft ring-4 ring-primary/20" />
                  <h3 className="text-lg font-semibold text-primary">{t.name}</h3>
                  <p className="badge-accent mt-2 inline-flex justify-center">{t.designation}</p>
                  <p className="text-sm text-text-secondary mb-3">{t.experience}</p>
                  <div className="flex items-center justify-center space-x-3">
                    {t.socials.map((s) => (
                      <a key={s.platform} href={s.url} className="text-primary hover:text-primary/80" aria-label={`${t.name} on ${s.platform}`}>
                        {s.icon}
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const subjects = [
  {
    name: 'Physics',
    faculty: [
      {
        name: 'Dr. Amit Kumar',
        designation: 'HOD Physics',
        image: '/faculty/amit-kumar.jpg',
        experience: '15+ years',
        socials: [
          {
            platform: 'linkedin',
            url: 'https://linkedin.com',
            icon: (
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            ),
          },
        ],
      },
    ],
  },
  {
    name: 'Chemistry',
    faculty: [
      {
        name: 'Dr. Priya Singh',
        designation: 'HOD Chemistry',
        image: '/faculty/priya-singh.jpg',
        experience: '12+ years',
        socials: [
          {
            platform: 'linkedin',
            url: 'https://linkedin.com',
            icon: (
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            ),
          },
        ],
      },
    ],
  },
  {
    name: 'Mathematics',
    faculty: [
      {
        name: 'Prof. Rajesh Verma',
        designation: 'HOD Maths',
        image: '/faculty/rajesh-verma.jpg',
        experience: '18+ years',
        socials: [
          {
            platform: 'linkedin',
            url: 'https://linkedin.com',
            icon: (
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            ),
          },
        ],
      },
    ],
  },
  {
    name: 'Biology',
    faculty: [
      {
        name: 'Dr. Meera Sharma',
        designation: 'HOD Biology',
        image: '/faculty/meera-sharma.jpg',
        experience: '14+ years',
        socials: [
          {
            platform: 'linkedin',
            url: 'https://linkedin.com',
            icon: (
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            ),
          },
        ],
      },
    ],
  },
];

export default FacultyPage;